var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box-container"},[_c('d-header',{attrs:{"fluid":"","breadcrumbs":false,"actions":_vm.actions}},[_c('h1',{staticClass:"title"},[_vm._v("\n      "+_vm._s(_vm.$t('application_files'))+"\n    ")])]),_vm._v(" "),_c('v-application-file-list',{attrs:{"property":_vm.model}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }